import React, { FC, FunctionComponent } from "react"
import { observer } from "mobx-react-lite"

import { useFocusEffect } from '@react-navigation/native';
import { SwipeListView, SwipeRow } from 'react-native-swipe-list-view';


import { AlertDialog, Spacer, } from "native-base"

import {
  StatusBar, Badge, Button, Icon, ButtonText, ButtonIcon, HStack, VStack, Text,
  View, AddIcon, Center, Box, Pressable, BadgeText
} from "@gluestack-ui/themed"


import { MaterialIcons, Ionicons, MaterialCommunityIcons, FontAwesome5, Entypo } from "@expo/vector-icons";

import { HomeStackParamList, useBackButtonHandler } from "../../navigators"
import { DrawerScreenProps } from "@react-navigation/drawer"
import { useStores } from "../../models"
import { ITEM_STATUS } from "../../voolks/types";
import { getIconItem, getItemTitle, openPDF } from "../../utils/itemCommonFunctions";
import { Platform } from "react-native";
import { customApp } from "../../config";
import { base64Encode, calcularVelocidadConexion } from "../../utils/general";

import { WebView } from 'react-native-webview';
import { WebView as WebViewForWeb } from 'react-native-web-webview';
import { ActionButton, ModalFull } from "../../components";
import NetInfo from '@react-native-community/netinfo';
import { useSwipeAnimation } from "../../utils/useSwipeAnimation";
import { ItemRow, HiddenActions } from "../../components/SwipeableItemRow";


export const ItemsListScreen: FC<DrawerScreenProps<HomeStackParamList, "ItemsList">> = observer(function FormsListScreen({ navigation, route }) {
  const fcName = "ItemsListScreen";
  console.log(fcName);
  let itemlistStatus = route.params.itemlistStatus;
  if (typeof (itemlistStatus) != "object")
    itemlistStatus = {};

  const [isSwiping, setIsSwiping] = React.useState(false);
  const rowMapRef = React.useRef<any>({});
  const swipeListRef = React.useRef(null);

  const offsetRef = React.useRef(itemlistStatus?.offset ?? 0);
  const { formsStore, itemsStore, statusStore, tasksStore, authenticationStore } = useStores();
  const [alertDialog, setAlertDialog] = React.useState(undefined);
  const [showCheck, setShowCheck] = React.useState<boolean>(false);
  const [itemsSelected, setItemsSelected] = React.useState<any[]>([]);
  const [showGraph, setShowGraph] = React.useState<boolean>(false);
  const [isConnected, setIsConnected] = React.useState<boolean>(true);

  React.useEffect(() => {
    const unsubscribe = NetInfo.addEventListener((state) => {
      setIsConnected(state.isConnected ?? false);
    });
    return () => unsubscribe();
  }, []);

  let department;
  if (route.params == undefined || route.params?.deptId == undefined)
    department = formsStore.mySubscriptions().subscriptions[0];
  else
    department = formsStore.mySubscriptions().subscriptions.find((dept: any) => dept.id == route.params?.deptId);
  if (department == undefined) {
    navigation.navigate("Settings");
    return <><Text></Text></>
  }
  const form = department.forms.find((form: any) => form.id == route.params.formId);
  if (form == undefined) {
    navigation.navigate("FormsList", { deptId: department.id });

    return <><Text></Text></>
  }
  const taskId = route.params.taskId;
  const tasks = taskId != undefined ? tasksStore.myTasks()?.tasks : [];
  const task: any = tasks?.find((item: any) => item.id == taskId)
  const swipeRows: any[] = [];
  const lastPressedBtn = React.useRef(0);
  let my_items: any = React.useMemo(() => {
    return itemsStore.myItems({ deptId: department.id, formId: form.id }).reverse();
  }, [itemsStore.itemsByUsersDB.length, route.params.formId]);
  const goBack = () => {
    if (taskId)
      navigation.navigate("TaskDetails", { taskId: taskId, fromTaskList: taskId != undefined });
    else
      navigation.navigate("FormsList", { deptId: department.id });

  }
const someToUpload =
    my_items.reduce((counter, item) => {
      return counter + (item.status == ITEM_STATUS.closed ? 1 : 0)
    }, 0);
  useBackButtonHandler(goBack);

  const newItem = async () => {
    console.log(fcName, "newItem", "init");
    if ((new Date().getTime() - lastPressedBtn.current) < 3000)
      return;
    lastPressedBtn.current = new Date().getTime();
    await itemsStore.new(form, taskId)
    _openItem();
  };

  const openItem = async (form, department, itemSelected: any = undefined) => {
    if ((new Date().getTime() - lastPressedBtn.current) < 3000)
      return;
    lastPressedBtn.current = new Date().getTime();
    _openItem(itemSelected);

  }

  const _openItem = async (itemSelected: any = undefined) => {
    console.log(fcName, "_openItem", "Init");
    if (itemSelected)
      await itemsStore.activateItem(itemSelected)
    if (itemsStore.itemActiveIDX != undefined) {
      let preValues = (task?.payload ?? []).reduce((fields, metadata) => {
        if (metadata?.fieldId)
          fields[metadata.fieldId] = metadata.value;
        return fields;
      }, {});

      await itemsStore.makePayloadFromFormPages(form.pages, preValues);
      navigation.navigate("ItemDetails", {
        itemStartedAt: new Date().getTime(),
        formId: form.id,
        deptId: department.id,
        forReview: itemsStore.itemActive.status != ITEM_STATUS.draft.toString(),
        taskId: taskId,
        pageActive: 0,
        rnd: new Date().getTime(),
        itemlistStatus: { offset: offsetRef.current }
      })
    }
    console.log(fcName, "_openItem", "Fin");
  }

  const cloneItem = async (form, department, itemSelected: any = undefined) => {
    offsetRef.current=0;
    await itemsStore.new(form, undefined, itemSelected)
    _openItem();
  }

  const removeItemsDialog = async (item: any = undefined) => {
    let lstIdx: number[] = [];
    let alert = { title: "", message: "" };
    if (item != undefined) {
      let itemIdx: number = itemsStore.getIDXofItem(item)
      if (itemIdx > -1) {
        lstIdx.push(itemIdx);
      }
      alert.title = "Borrar registro";
      alert.message = `¿Estas seguro de borrar el registro  ${getItemTitle(form, item)}?`;
    } else {
      let lstTitles: string[] = [];
      itemsSelected.forEach((item) => {
        let itemIdx: number | undefined = itemsStore.getIDXofItem(item)
        if (itemIdx != undefined) {
          lstTitles.push(getItemTitle(form, item));
          lstIdx.push(itemIdx)
        }
      })
      alert.title = "Borrar multiples registros";
      alert.message = `¿Estas seguro de borrar los registros  ${lstTitles.join(", ")}?`;
    }
    if (lstIdx.length > 0) {
      setAlertDialog({
        ...alert,
        action: () => {
          swipeRows.map(async (row) => {
            await row?.closeRow();
          });
          lstIdx.sort((a, b) => { return b - a; }).forEach(idx => itemsStore.removeItem(idx));
          setShowCheck(false);
        }
      })
    }
  }

  const checkAll = async () => {
    let selItems = Array.from(itemsSelected);
    await my_items.map(async (item: any) => {
      if (isItemSelected(item)) {
        selItems.splice(selItems.indexOf(item), 1)
      } else {
        selItems.push(item);
      }
    });
    setItemsSelected(selItems);
  }

  const isItemSelected = (item: any) => {
    return itemsSelected.includes(item)
  }
  const selectItem = (item: any) => {
    console.log(new Date().toISOString(), "selectItem IN");
    let selItems = Array.from(itemsSelected);
    if (isItemSelected(item)) {
      selItems.splice(selItems.indexOf(item), 1)
    } else {
      selItems.push(item);
    }
    setItemsSelected(selItems);
    console.log(new Date().toISOString(), "selectItem OUT");
    return selItems;
  }

  const getGraph = () => {
    const token = authenticationStore.userInfo.userToken;
    const url = `app/#/graph/${form.graphId}?departmentId=${department.id}`
    return `${customApp.graphsUrl || customApp.baseUrl}app/loadfromApp.html#${base64Encode("token=".concat(token, "&user=", authenticationStore.userInfo.id, "&url=", url))}`;
  }

  const renderHiddenItem = React.useCallback((data, rowMap) => {
    rowMapRef.current = rowMap;

    if (!department || !form) return <></>;

    return (
      <HiddenActions
        item={data.item}
        form={form}
        department={department}
        onClone={cloneItem}
        onPDF={(it, mail) => openPDF(itemsStore, it, mail)}
        onRemove={removeItemsDialog}
      />
    );
  }, [my_items]);

  useFocusEffect(
    React.useCallback(() => {
      if (swipeListRef.current && offsetRef.current > 0) {
        setTimeout(() => {
          console.log("offsetRef.current", offsetRef.current);
          swipeListRef.current?._listView?.scrollToOffset({
            offset: offsetRef.current,
            animated: false,
          });
        }, 200);
      }
    }, [])
  );
  const heightsMap = React.useRef({});
  const renderItem = 
    (data, rowMap) => {
      rowMapRef.current = rowMap;
        console.log("renderItem Item", data.item.title, data.item.status)

      if (data.item.title == undefined || data.item.title == "")
        data.item.title = getItemTitle(form, data.item)
      return (
        <ItemRow
          item={data.item}
          department={department}
          form={form}
          onPress={openItem}
          isSwiping={isSwiping}
          statusStore={statusStore}
          currentStateOnly={undefined}
          navigation={navigation}
          fromTaskId={taskId}
          showCheck = {showCheck}
          selectItem = {selectItem}
          itemsSelected = {itemsSelected}
          onLayout={(event) => {
          //  console.log("ItemRow onLayout ", data.item.id, event.nativeEvent.layout, data.index);
            heightsMap.current[data.index] = event.nativeEvent.layout.height;
          }}
        />
      );
    }

  const renderItemsListRows = () => {
    return (
      <SwipeListView
        ref={swipeListRef}
        useFlatList={true} initialNumToRender={15}
        maxToRenderPerBatch={2}
        onScroll={(event) => {
          offsetRef.current = event.nativeEvent.contentOffset.y;
        }}
        onSwipeValueChange={({ value }) => {
          if (value !== 0) setIsSwiping(true); // Detecta swipe activo
          else setIsSwiping(false); // Resetea al finalizar el swipe
        }}
        data={my_items}
        renderItem={renderItem}
        keyExtractor={(item, index) => (`idx-${index}`)}
        leftOpenValue={170}
        rightOpenValue={-60}
        renderHiddenItem={renderHiddenItem}

        onRowOpen={handleRowOpen}
      />
    )
  }
  

  const cancelRef = React.useRef();

  let leftButton = <Button width={50} height={50} p="$1" variant="solid" key="actionButton-nextPage" onPress={goBack}>
    <ButtonIcon as={Ionicons} name="arrow-back" fontWeight="$extrabold" size="xl" color="#FFF" />
  </Button>;

  const { handleRowOpen } = useSwipeAnimation({
    needShowAnimation: () => statusStore.needShowLastSwipeAnimation(),
    setLastAnimation: () => statusStore.setLastSwipeAnimation(),
    itemsLength: my_items.length,
    rowMapRef,
  });

  return statusStore.status == "pending" ? <></> :(<>
    <StatusBar backgroundColor={"#3700B3"} barStyle="light-content" />
    <Box bg="primary.400" />
    <HStack bg="$primary400" paddingHorizontal={0} paddingVertical={0} justifyContent="space-between" alignItems="center" w="100%">
      <HStack alignItems="center" maxWidth={statusStore.windowDimensions.width - 140}  >
        {leftButton}
        <Text color="white" fontSize={18} marginLeft={1} minWidth="50%">
          {form.name}
        </Text>
      </HStack>
      <HStack>
        {form.graphId != null && form.graphId != "" ?
          <Button width={50} height={50} p="$1" variant="solid" key="itemsStore-graph" isDisabled={!isConnected}
            onPress={() => setShowGraph(true)}>
            <ButtonIcon as={Ionicons} name="pie-chart-sharp" fontWeight="$extrabold" size="xl" color={isConnected ? "#FFF" : "$light400"} />
          </Button>
          : <></>}
        {someToUpload > 0 ?
          <VStack>
            <Badge h={22} w={22} bg="$red600" borderRadius="$full" mb={-22} mr={0} zIndex={1}
              variant="solid" alignSelf="flex-end" ><BadgeText size="2xs" color="$white">{someToUpload}</BadgeText>
            </Badge>
            <Button width={55} height={55} p="$1" variant="solid" key="itemsStore-upload" onPress={() => itemsStore.upload({ deptId: department.id, formId: form.id })}>
              <ButtonIcon as={MaterialCommunityIcons} name="cloud-upload" fontWeight="$extrabold" size="xl" color="#FFF" />
            </Button>
          </VStack>
          : <Button width={50} height={50} p="$1" variant="solid" key="itemsStore-resync"
            onPress={() => formsStore.getSubscriptions(true, true)}>
            <ButtonIcon as={Ionicons} name="refresh-outline" fontWeight="$extrabold" size="xl" color="#FFF" />
          </Button>
        }
        {showCheck ?
          <Button width={50} height={50} p="$1" variant="solid" key="itemsStore-upload" onPress={checkAll}>
            <ButtonIcon as={MaterialCommunityIcons} name="checkbox-multiple-marked" fontWeight="$extrabold" size="xl" color="#FFF" />
          </Button>
          :
          <Button width={50} height={50} p="$1" variant="solid" key="itemsStore-upload" onPress={newItem}>
            <ButtonIcon as={Ionicons} name="add" fontWeight="$extrabold" size="xl" color="#FFF" />
          </Button>
        }
      </HStack>
    </HStack>
    {task ?
      <HStack key={`r2`} bgColor={"light.200"} px="5" py="2" my="0" justifyContent="flex-start" alignItems="center" w="100%" borderBottomWidth={1} borderBottomColor={"$light300"} >
        <Icon name="event" size="lg" mr="3" color={"secondary.400"} as={MaterialIcons} />
        <Text size="md" color="secondary.400"> {task.name}</Text>
      </HStack>
      :
      <></>
    }
    <VStack bg="$white" flex={1}>
      {my_items.length == 0 ? <Center margin={"auto"} alignItems="center" width={"100%"} height={"100%"}>
        <Button margin="auto" onPress={newItem} width={"100%"}
          variant="solid"
          action="secondary"
          isDisabled={false}
          isFocusVisible={false}
        >
          <ButtonText>INGRESAR NUEVO REGISTRO </ButtonText>
          <ButtonIcon as={AddIcon} />
        </Button>
      </Center>
        :
        <>
          {renderItemsListRows()}
          <Spacer />
          <VStack backgroundColor="$primary400" style={{ marginTop: 50 }}>
            <HStack>
              {!showCheck ? <>
                <ActionButton key="actionButton-add"
                  withTitles={true}
                  isValidItem={true}
                  iconName="add"
                  iconFamily={Ionicons}
                  title="Nuevo"
                  onPress={newItem}
                />
                <ActionButton key="actionButton-sync"
                  withTitles={true}
                  isValidItem={true}
                  iconName="refresh-outline"
                  iconFamily={Ionicons}
                  title="Sincronizar"
                  onPress={() => formsStore.getSubscriptions(true, true)}
                />

                <Spacer></Spacer>
                <ActionButton key="actionButton-remove"
                  withTitles={true}
                  isValidItem={true}
                  iconName="trash-outline"
                  iconFamily={Ionicons}
                  title="Borrar"
                  onPress={() => { setShowCheck(!showCheck); }}
                />
              </> : <></>}
              {showCheck ?
                <>

                  <Button height={50} p="$1" borderColor="$success600"
                    variant={"outline"} bgColor={"$white"} key="itemsStore-trashcancel"
                    onPress={() => setShowCheck(!showCheck)}>
                    <ButtonIcon as={Ionicons} name="close" fontWeight="$extrabold" size="xl" color={"$black"} />
                    <Text>Cancelar</Text>

                  </Button><Spacer />
                  <Button height={50} p="$1" borderColor="$danger600" disabled={itemsSelected.length == 0}
                    variant={"outline"} bgColor={"$white"} key="itemsStore-trashcheckmark"
                    onPress={() => removeItemsDialog()}>
                    <ButtonIcon as={Ionicons} name="checkmark" fontWeight="$extrabold" size="xl" color={"$danger400"} />
                    <Text>Confirmar</Text>
                  </Button>
                </>
                :
                <></>}
            </HStack></VStack>
        </>
      }
    </VStack>
    {alertDialog == undefined ? <></> :
      <AlertDialog leastDestructiveRef={cancelRef} isOpen={alertDialog != undefined} >
        <AlertDialog.Content>
          <AlertDialog.CloseButton />
          <AlertDialog.Header>{alertDialog?.title}</AlertDialog.Header>
          <AlertDialog.Body>{alertDialog?.message}</AlertDialog.Body>
          <AlertDialog.Footer>
            <Button ref={cancelRef} onPress={() => setAlertDialog(undefined)}>
              <ButtonText>Cancelar</ButtonText>
            </Button>
            <Button action="negative" ml={3} onPress={() => { alertDialog?.action(); setAlertDialog(undefined) }}>
              <ButtonText>Aceptar</ButtonText>
            </Button>
          </AlertDialog.Footer>
        </AlertDialog.Content>
      </AlertDialog>
    }

    {showGraph ? <ModalFull visible={showGraph} closeButton_onPress={() => setShowGraph(false)} title={form.name}>
      {
        Platform.OS != "web" ?
          <WebView
            source={{ uri: `${getGraph()}` }}
            originWhitelist={['*']}
            injectedJavaScript={`
                                                const meta = document.createElement('meta');
                                                meta.setAttribute('content', 'initial-scale=0.5, maximum-scale=1.0, user-scalable=yes');
                                                meta.setAttribute('name', 'viewport');
                                                document.head.appendChild(meta);
                                                document.body.style.zoom = "1";
                                                true;
                                              `}
            scalesPageToFit={true}
            style={{
              width: statusStore.windowDimensions.width,
              height: (statusStore.windowDimensions.height - 150),

            }}
          />
          :
          <View style={{ flex: 1, overflow: 'hidden' }}>
            <View style={{
              width: '117.6%',
              height: '117.6%',
              transform: [{ scale: 0.85 }],
              transformOrigin: 'top left' as any,
            }}>
              <WebViewForWeb
                startInLoadingState={true}
                source={{ uri: `${getGraph()}` }}
                style={{ flex: 1, width: "100%", height: "100%", backgroundColor: "transparent" }}
                hideStatusBar={false}
                hideAddressBar={false}
                javaScriptEnabled={true}
                originWhitelist={['*']}
                hideActivityIndicator={false}
              />
            </View>
          </View>
      }
    </ModalFull> : <></>}

  </>
  )
})